import type { Requests } from "../common/request.common";
import type { ResellerInvoiceResponseTypes } from "../common/response.common";
import { get, post } from "./common";

export const resellerInvoice = {
    record(resellerId?: string) {
        return (data: typeof Requests.ResellerInvoice.Record.Input) => {
            return post<typeof data, ResellerInvoiceResponseTypes.Record>(
                `/reseller-invoice/record/${resellerId ?? ""}`,
                data,
            );
        };
    },
    entries(data: typeof Requests.ResellerInvoice.Entries.Input) {
        return post<typeof data, ResellerInvoiceResponseTypes.Entries>(
            `/reseller-invoice/entries`,
            data,
        );
    },
    create(data: typeof Requests.ResellerInvoice.Create.Input) {
        return post<typeof data>(`/reseller-invoice/create`, data);
    },
    obtain(id: string) {
        return get<ResellerInvoiceResponseTypes.Obtain>(`/reseller-invoice/obtain/${id}`);
    },
};
